import React, {useCallback, useState, useEffect, useMemo} from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, Row} from "reactstrap5";
import {FormattedDate, FormattedMessage, FormattedNumber} from "react-intl";
import NotLoggedModal from "../Modals/NotLogged";
import PropTypes from "prop-types";
import StudentModal from "../Modals/Student";
import iconCheck from "../../../images/modal-icon-check.svg";
import iconArrow from "../../../images/modal-icon-arrow.svg";
import iconInfo from "../../../images/icon_info.svg";
import stopIcon from "../../../images/modal-icon-stop2.svg";

const OrderCard = ({config}) => {
    const data = useMemo(() => {
        const parseData = JSON.parse(config.productsData);
        let result = {};
        const newFamilyData = parseData['new-family'] ?? null;

        if (newFamilyData && newFamilyData.upgrade) {
            result.family = parseData['upgrade-family'] ?? null
        } else {
            result.family = newFamilyData;
        }

        const newTeacherData = parseData['new-teacher'] ?? null;

        if (newTeacherData && newTeacherData.upgrade) {
            result.teacher = parseData['upgrade-teacher'] ?? null
        } else {
            result.teacher = newTeacherData;
        }

        return result;
    }, [config.productsData]);
    const [premiumType, setPremiumType] = useState(window.setPremiumTab ?? (window.location.hash === '#tab-teacher' ? 'teacher' : 'family'));
    const mode = useMemo(() => data[premiumType].upgrade ? 'upgrade' : 'new', [data, premiumType]);
    const [licences, setLicences] = useState(1);
    const [period, setPeriod] = useState(365);
    const [showModal, setShowModal] = useState(false);
    const [countLicences, setCountLicences] = useState([]);
    const [periods, setPeriods] = useState([]);
    console.log(mode, premiumType);

    useEffect(() => {
        console.log(data[premiumType]);
        if (data[premiumType] && data[premiumType].products) {
            const newCountLicences = [...new Set(data[premiumType].products.map((product) => product.countLicences))];
            const newPeriods = [...new Set(data[premiumType].products.map((product) => product.period))];
            console.log(newCountLicences, newPeriods);

            if (newCountLicences.length && !newCountLicences.filter((count) => count == licences).length) {
                setLicences(newCountLicences[0]);
            }

            if (data[premiumType].recommended && data[premiumType].recommended.countLicences != licences && newCountLicences.length && newCountLicences.filter((count) => count == data[premiumType].recommended.countLicences).length) {
                setLicences(data[premiumType].recommended.countLicences);
            }

            if (newPeriods.length && !newPeriods.filter((length) => length == period).length) {
                setPeriod(newPeriods[0]);
            }

            if (data[premiumType].recommended && data[premiumType].recommended.period != period && newPeriods.length && newPeriods.filter((length) => length == data[premiumType].recommended.period).length) {
                setPeriod(data[premiumType].recommended.period);
            }

            setCountLicences(newCountLicences);
            setPeriods(newPeriods);
        }
    }, [premiumType, data]);


    const buy = useCallback(() => {

        if (!data[premiumType]) {
            return;
        }

        if (data[premiumType].canBuy) {
            window.location.href = data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.url;
            return;
        }

        setShowModal(true);

    }, [data, setShowModal, period, licences]);

    window.addEventListener("message", (event) => {
        if (event.data.type === "premiumTabChange") {
            setPremiumType(event.data.tab);
        }
    });

    return (
        <>

            <Card className="card--order text-body mx-3 mx-lg-0">
                {mode === 'upgrade' && <CardHeader className="text-body border-bottom flex-column px-3 px-lg-4">
                    <div>
                        <h4 className="text-18 m-0">
                            <FormattedMessage defaultMessage="Co chci udělat"/>
                        </h4>
                    </div>
                    <div>
                        <ButtonGroup className="my-2">
                            <Button color={mode === 'upgrade' ? '-blue' : '-outline-blue'}
                                    className="fw-bold py-1 text-15">
                                <FormattedMessage defaultMessage="Změnit stávající licenci"/>
                            </Button>
                            <Button color={mode === 'new' ? '-blue' : '-outline-blue'} className="fw-bold py-1 text-15"
                                    disabled={true}>
                                <FormattedMessage defaultMessage="Koupit novou licenci"/>
                            </Button>
                        </ButtonGroup>
                    </div>
                </CardHeader>}
                {data[premiumType] && data[premiumType].existsLicence && <div className="bg-dark-gray p-2 px-4 d-flex">
                    <img src={iconInfo} className="pe-2"/>
                    <span>
                        <FormattedMessage defaultMessage="Vaše stávající licence pro"/>{' '}
                        <strong>{data[premiumType].existsLicence.countLicencesText}</strong>{' '}
                        <FormattedMessage defaultMessage="je platná do"/>{' '}
                        <strong>
                            <FormattedDate value={data[premiumType].existsLicence.timeActivateTo}/>
                        </strong>{'. '}
                        {data[premiumType].upgrade && data[premiumType].products.length > 0 && <>
                            <FormattedMessage defaultMessage="V rámci změny je možné navýšit počet"/>{' '}
                            {premiumType === 'teacher' && <FormattedMessage defaultMessage="tříd"/>}
                            {premiumType === 'family' && <FormattedMessage defaultMessage="dětí"/>}
                            {'.'}
                        </>}
                        {data[premiumType].upgrade && !data[premiumType].products.length && <>
                            <FormattedMessage
                                defaultMessage="Bohužel již máte maximální počet licencí a již nelze upgrade provést"/>
                            {'.'}
                        </>}
                        {!data[premiumType].upgrade && <>
                            <FormattedMessage
                                defaultMessage="Licenci již nelze změnit, ale lze koupit novou podle vašich požadavků."/>
                        </>}
                    </span>
                </div>}
                <CardHeader className="text-body border-bottom px-3 px-lg-4">
                    <h4 className="text-18 m-0">
                        {mode === 'new' && <FormattedMessage defaultMessage="Objednat Škola s{nbsp}nadhledem PREMIUM"
                                                       values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>}
                        {mode === 'upgrade' &&
                            <FormattedMessage defaultMessage="Změnit stávající licenci Škola s{nbsp}nadhledem PREMIUM"
                                              values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>}
                    </h4>
                </CardHeader>
                <CardBody>
                    <Row>
                        {mode === 'new' && <Col xs={12} lg={6} className="border--end px-2 px-lg-3 pb-4 mb-4 mb-lg-0">
                            <h4 className="text-18 m-0">
                                <FormattedMessage defaultMessage="1. Jsem"/>
                            </h4>

                            <ButtonGroup className="my-2">
                                <Button color={premiumType === 'family' ? '-blue' : '-outline-blue'}
                                        className="fw-bold py-1 text-15"
                                        onClick={() => setPremiumType('family')}>
                                    <FormattedMessage defaultMessage="Rodič"/>
                                </Button>
                                <Button color={premiumType === 'teacher' ? '-blue' : '-outline-blue'}
                                        className="fw-bold py-1 text-15"
                                        onClick={() => setPremiumType('teacher')}>
                                    <FormattedMessage defaultMessage="Učitel"/>
                                </Button>
                            </ButtonGroup>

                            {premiumType === 'family' &&
                                <div className="d-none d-lg-block">
                                    <h5 className="text-14 mt-3">
                                        <FormattedMessage defaultMessage="Co jako rodič získáte?"/>
                                    </h5>

                                    <p className="text-14">
                                        <FormattedMessage
                                            defaultMessage="Chcete děti motivovat, aby je učení více bavilo? S{nbsp}tím pomůže Premium účet a{nbsp}Rodičovská licence."
                                            values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}
                                        />
                                    </p>

                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Kompletní přehled o{nbsp}procvičování svých dětí."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Možnost porovnání výsledků Vašich dětí s{nbsp}výsledky jejich vrstevníků."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Motivaci pro Vaše děti v{nbsp}podobě sbírání odznaků za dobře odvedenou práci."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage defaultMessage="Adblock."/>
                                        </div>
                                    </div>
                                </div>
                            }

                            {premiumType === 'teacher' &&
                                <div className="d-none d-lg-block">
                                    <h5 className="text-14 mt-3">
                                        <FormattedMessage defaultMessage="Co jako učitel získáte?"/>
                                    </h5>

                                    <p className="text-14">
                                        <FormattedMessage
                                            defaultMessage="Už máte dost věčného opravování stohů sešitů? {nbsp}tím pomůže Premium účet a{nbsp}Učitelská licence."
                                            values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}
                                        />
                                    </p>

                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Možnost zadávat domácí úkoly hromadně i{nbsp}jednotlivě, navíc bez nutnosti je opravovat."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Přehled o{nbsp}vývoji znalostí svých žáků ve svých třídách."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage
                                                defaultMessage="Anonymní srovnání výsledků žáků z{nbsp}Vaší třídy s&nbsp;výsledky jejich vrstevníků."
                                                values={{nbsp: <React.Fragment>&nbsp;</React.Fragment>}}/>
                                        </div>
                                    </div>
                                    <div className="d-flex text-body text-14 py-2">
                                        <img src={iconCheck}/>

                                        <div className="ps-2">
                                            <FormattedMessage defaultMessage="Adblock."/>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Col>}

                        {mode === 'upgrade' && countLicences.length > 0 &&
                            <Col xs={12} lg={6} className="border--end px-2 px-lg-3 pb-4 mb-3 mb-lg-0">
                                <h4 className="text-18 m-0">
                                    {premiumType === 'family' && <FormattedMessage defaultMessage="1. Počet dětí"/>}
                                    {premiumType === 'teacher' && <FormattedMessage defaultMessage="1. Počet tříd"/>}
                                </h4>

                                <ButtonGroup className="my-2">

                                    {
                                        countLicences.sort((a, b) => (a - b)).map((count, index, arr) => (
                                            <Button color={licences == count ? '-blue' : '-outline-blue'}
                                                    className="fw-bold py-1 text-15"
                                                    onClick={() => setLicences(count)}>
                                                {(countLicences.length - 1) !== index && count}
                                                {(countLicences.length - 1) === index && index > 0 &&
                                                    <FormattedMessage defaultMessage="{count} a více"
                                                                      values={{count: arr[index - 1] + 1}}/>}
                                                {(countLicences.length - 1) === index && index === 0 && data[premiumType].products[0].countLicencesText}
                                            </Button>
                                        ))
                                    }
                                </ButtonGroup>
                            </Col>}

                        {mode === 'new' && countLicences.length > 0 && <Col xs={12} lg={6} className="ps-lg-4 px-2 px-lg-3">
                            <h4 className="text-18 m-0">
                                {premiumType === 'family' && <FormattedMessage defaultMessage="2. Počet dětí"/>}
                                {premiumType === 'teacher' && <FormattedMessage defaultMessage="2. Počet tříd"/>}
                            </h4>

                            <ButtonGroup className="my-2">

                                {
                                    countLicences.sort((a, b) => (a - b)).map((count, index, arr) => (
                                        <Button color={licences == count ? '-blue' : '-outline-blue'}
                                                className="fw-bold py-1 text-15"
                                                onClick={() => setLicences(count)}>
                                            {(countLicences.length - 1) !== index && count}
                                            {(countLicences.length - 1) === index &&
                                                <FormattedMessage defaultMessage="{count} a více"
                                                                  values={{count: arr[index - 1] + 1}}/>}
                                        </Button>
                                    ))
                                }
                            </ButtonGroup>

                            <h4 className="text-18 m-0 pt-4 pt-lg-3">
                                <FormattedMessage defaultMessage="3. Délka předplatného"/>
                            </h4>

                            <ButtonGroup className="my-2">

                                {
                                    periods.sort((a, b) => (a - b)).map((length) => (
                                        <Button color={period == length ? '-blue' : '-outline-blue'}
                                                className="fw-bold py-1 text-15"
                                                onClick={() => setPeriod(length)}>
                                            {data[premiumType].products.filter((product) => product.period === length)[0]?.periodText}
                                        </Button>
                                    ))
                                }
                            </ButtonGroup>

                            <div className="border--top mt-4 mt-lg-3">

                            </div>

                            <h4 className="text-18 m-0 pt-4 pt-lg-3">
                                <FormattedMessage defaultMessage="4. Vaše cena"/>
                            </h4>

                            {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.price !== product.prediscountPrice && product.discountInfo).length > 0 &&
                                <div className="text-danger">
                                    {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.discountInfo}
                                </div>}

                            <div className="text-30">
                                {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences).length &&
                                    <FormattedNumber
                                        value={data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.price}
                                        style="currency"
                                        currency="CZK"/>}
                                {' '}
                                {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.price !== product.prediscountPrice).length > 0 &&
                                    <del className="ps-3">
                                        <FormattedNumber
                                            value={data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.prediscountPrice}
                                            style="currency"
                                            currency="CZK"/>
                                    </del>}
                            </div>

                            {
                                data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && !product.canBuy).length > 0 &&
                                <div className="mt-3 text-danger">
                                    {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && !product.canBuy)[0].reason}
                                </div>
                            }

                            <Button color="-blue" className="mt-3 text-17"
                                    disabled={!data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.canBuy).length}
                                    onClick={buy}>
                                <strong className="pe-2"><FormattedMessage defaultMessage="Objednat"/></strong>
                                <img src={iconArrow}/>
                            </Button>

                            {data[premiumType] && data[premiumType].existsInBasket && <div className="mt-3 text-orange"><FormattedMessage
                                defaultMessage="V jedné objednávce nelze najednou objednat rodičovskou a učitelskou licenci. Potvrzením dojde k vymazání původní licence z košíku."/>
                            </div>}
                        </Col>}

                        {mode === 'upgrade' && data[premiumType].products.length > 0 &&
                            <Col xs={12} lg={6} className="ps-lg-4  px-2 px-lg-3">
                                <h4 className="text-18 m-0 pt-3">
                                    <FormattedMessage defaultMessage="2. Vaše cena"/>
                                </h4>

                                {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.price !== product.prediscountPrice && product.discountInfo).length > 0 &&
                                    <div className="text-danger">
                                        {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.discountInfo}
                                    </div>}

                                <div className="text-30">
                                    {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences).length &&
                                        <FormattedNumber
                                            value={data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.price}
                                            style="currency"
                                            currency="CZK"/>}
                                    {' '}
                                    {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.price !== product.prediscountPrice).length > 0 &&
                                        <del className="ps-3">
                                            <FormattedNumber
                                                value={data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.prediscountPrice}
                                                style="currency"
                                                currency="CZK"/>
                                        </del>}
                                </div>

                                {
                                    data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && !product.canBuy).length > 0 &&
                                    <div className="mt-3 text-danger">
                                        {data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && !product.canBuy)[0].reason}
                                    </div>
                                }

                                <Button color="-blue" className="mt-3 text-17"
                                        disabled={!data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences && product.canBuy).length}
                                        onClick={buy}>
                                    <strong className="pe-2"><FormattedMessage defaultMessage="Objednat"/></strong>
                                    <img src={iconArrow}/>
                                </Button>

                                {data[premiumType] && data[premiumType].existsInBasket &&
                                    <div className="mt-3 text-orange"><FormattedMessage
                                        defaultMessage="V jedné objednávce nelze najednou objednat rodičovskou a učitelskou licenci. Potvrzením dojde k vymazání původní licence z košíku."/>
                                    </div>}
                            </Col>}

                        {mode === 'upgrade' && data[premiumType] && !data[premiumType].products.length &&
                            <div className="bg--warning p-2 px-4 d-flex rounded">
                                <img src={stopIcon} className="pe-2 max-width-28px"/>
                                <span>
                                <FormattedMessage
                                    defaultMessage="Aktuálně nemůžete zvýšit počet licencí, protože již máte maximální počet."/>
                            </span>
                            </div>}

                        {mode === 'new' && data[premiumType] && !data[premiumType].products.length &&
                            <div className="bg--warning p-2 px-4 d-flex rounded mt-5 zindex-1">
                                <img src={stopIcon} className="pe-2 max-width-28px"/>
                                <span>
                                <FormattedMessage
                                    defaultMessage="Aktuálně nemůže zakoupit další licenci, protože jednu navazující máte již zakoupenou."/>
                            </span>
                            </div>}
                    </Row>
                </CardBody>
            </Card>

            {showModal && !data[premiumType].canBuy && data[premiumType].reason === 'notLogged' &&
                <NotLoggedModal afterClose={() => setShowModal(false)}
                                link={data[premiumType].products.filter((product) => product.period === period && product.countLicences === licences)[0]?.url}/>}
            {showModal && !data[premiumType].canBuy && data[premiumType].reason === 'child' &&
                <StudentModal afterClose={() => setShowModal(false)} config={config}/>}
        </>
    );

};

OrderCard.propTypes = {
    config: PropTypes.object.isRequired
};

OrderCard.defaultProps = {}

export default OrderCard;
